import * as $ from 'jquery';
import { orderPaymentEdit } from '../../../../redux/actions/order/orderPaymentActions';
import Alert from '../../../../itrust_common/components/Alert';
import { orderUpdate } from '../../../../redux/actions/order/orderActions';
import { useDispatch, useSelector } from 'react-redux';
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView';
import { getFormValues } from 'redux-form';

export default function FinalizeButton(props) {
  const { children, onFinalize, orderStaffId, balanceDue, patientName, orderId, showRequiredAuth } = props
  const dispatch = useDispatch()
  const activeTab = useSelector(state => state.other.activeTab.order)

  const getActiveFormName = () => {
    switch (activeTab) {
      case 1: return 'orderProcedureForm'
      case 2: return 'orderContactLensForm'
      case 3: return 'orderEyeglassForm'
      case 4: return 'orderMiscItemForm'
      case 6: return '1500ClamForm'
      default: return null
    }
  }

  const activeFormName = getActiveFormName()
  const formData = useSelector(state => activeFormName ? getFormValues(activeFormName)(state) : {})

  const handlePaymentEdit = (e) => {
    e.stopPropagation();
    if (showRequiredAuth) {
      Alert.warning("Please enter 1500 Prior Authorization Number to Pay & Finalize this order.")
      return
    }
    if (orderStaffId) {
      if (balanceDue) {
        onFinalize()
        dispatch(orderPaymentEdit('New'))
        $("#orderFinalizeForm-modal").modal()
      }
      else {
        Alert.confirm(<div>The balance due is <strong><CurrencyTypeView amount={balanceDue} /></strong>. You're finalizing order for <strong>{patientName}</strong>.</div>,
          (res) => {
            if (res) {
              dispatch(orderUpdate({ ...(formData || {}), id: orderId, status: 'finalized' }, { include: '*' }))
            }
          }
        )
      }
    }
    else {
      Alert.warning("Please select provider to finalize the order.")
    }
  }

  return (
    <span className="pointer" onClick={handlePaymentEdit}>
      {children}
    </span>
  )
}